// LearningInsights.jsx
import React, { useState, useEffect } from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import baseUrl from '../../config';

const LearningInsights = () => {
  const [insights, setInsights] = useState({ hoursStudied: 0, tasksCompleted: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInsights = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token'); // Get token from localStorage (or wherever you store it)

        if (!token) {
          setError(new Error("Authentication token not found. Please log in."));
          setLoading(false);
          return;
        }

        const response = await fetch(baseUrl  + 'api/students/v2/learning-insights', { // No studentId in URL
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Send the token in the Authorization header
            // Or 'x-auth-token': token, depending on your middleware
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setInsights(data);
      } catch (err) {
        console.error("Failed to fetch learning insights:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInsights();
  }, []); // Empty dependency array as studentId is no longer a prop

  if (loading) {
    return <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-blue-600 transition-all duration-300">Loading insights...</div>;
  }

  if (error) {
    return <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-blue-600 transition-all duration-300 text-red-600">Error: {error.message}</div>;
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-blue-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
        <ChartBarIcon className="w-8 h-8 mr-3 text-blue-600" />
        Learning Insights
      </h2>
      <p className="text-lg text-gray-700 mb-4">Track your progress and see how far you've come!</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div className="bg-blue-100 p-4 rounded-lg shadow-sm flex items-center space-x-3">
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl border-2 border-blue-600">
            📊
          </div>
          <div>
            <p className="font-semibold text-blue-600">Hours Studied</p>
            <p className="text-2xl font-bold text-gray-800">{insights.hoursStudied}</p>
          </div>
        </div>
        <div className="bg-blue-100 p-4 rounded-lg shadow-sm flex items-center space-x-3">
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl border-2 border-blue-600">
            ✅
          </div>
          <div>
            <p className="font-semibold text-blue-600">Tasks Completed</p>
            <p className="text-2xl font-bold text-gray-800">{insights.tasksCompleted}</p>
          </div>
        </div>
      </div>
      {/* <button className="w-full bg-blue-600 text-white py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors shadow-md">
        View Detailed Stats
      </button> */}
    </div>
  );
};

export default LearningInsights;